import { useTranslation } from 'react-i18next';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { MARKET } from '@/common/constants/markets';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { useMarket } from '@/web/hooks/useMarket';

export const ProfileHelpSection = () => {
  const { slug, marketMatch } = useMarket();
  const { t } = useTranslation();
  const showAdditionalLinks = marketMatch(MARKET.ES, MARKET.IT);
  return (
    <CardActionGroup
      title={t('dashboard.profile.sections.support.title')}
      size="sm"
    >
      <CardAction
        onPress={() => AnalyticsService.openChat()}
        icon={<Icon icon="message" />}
        title={t('dashboard.profile.sections.support.links.chat_with_us.title')}
        action={<Icon icon="chevron-right" />}
      />
      {slug === MARKET.PT && (
        <CardActionLink
          href={t('dashboard.profile.sections.support.links.whatsapp.href')}
          icon={<Icon icon={['fab', 'whatsapp']} />}
          title="WhatsApp"
          external
        />
      )}
      <CardActionLink
        href={t(`help_link.faq.${slug}`)}
        icon={<Icon icon="question" />}
        title={t('dashboard.profile.sections.support.links.faq.title')}
        external
      />
      <CardActionLink
        href={t(`general.links.terms_of_use.${slug}.url`)}
        icon={<Icon icon="file-lines" />}
        title={t(
          'dashboard.profile.sections.support.links.terms_conditions.title'
        )}
        external
      />
      <CardActionLink
        href={t(`general.links.privacy_policy.${slug}.url`)}
        icon={<Icon icon="file-lines" />}
        title={t(
          'dashboard.profile.sections.support.links.privacy_policy.title'
        )}
        external
      />
      {showAdditionalLinks && (
        <CardActionLink
          href={t(`help_link.monavate.${slug}`)}
          icon={<Icon icon="file-lines" />}
          title={t('dashboard.profile.sections.support.links.monavate.title')}
          description={t(
            'dashboard.profile.sections.support.links.monavate.description'
          )}
          external
        />
      )}
      {showAdditionalLinks && (
        <CardActionLink
          href={t(`help_link.3ds.${slug}`)}
          icon={<Icon icon="file-lock" />}
          title={t('dashboard.profile.sections.support.links.3ds.title')}
          description={t(
            'dashboard.profile.sections.support.links.3ds.description'
          )}
          external
        />
      )}
    </CardActionGroup>
  );
};
